import { gql } from '@/features/graphql/generated'

export const OpenTabItemChangeQuantityDocument = gql(/* GraphQL */ `
    mutation OpenTabItemChangeQuantity($openTabUuid: ID!, $input: OpenTabItemChangeQuantityInput!) {
        openTabItemChangeQuantity(openTabUuid: $openTabUuid, input: $input) {
            uuid
        }
    }
`)

export const OpenTabItemRemoveDocument = gql(/* GraphQL */ `
    mutation OpenTabItemRemove($openTabUuid: ID!, $itemUuid: ID!) {
        openTabItemRemove(openTabUuid: $openTabUuid, itemUuid: $itemUuid) {
            uuid
        }
    }
`)
